import pattern from 'patterns/link';
import { WCCContentLinkBlock } from '../blocks/link/link';
import WCCContentPatternRule from './pattern';

export default class WCCContentLinkRule extends WCCContentPatternRule {
    protected pattern = pattern;

    protected process(match: RegExpMatchArray) {
        const url = $.trim(match[0]);
        const protocol = match[1] ?? '';
        const dns = match[2] ?? '';

        return new WCCContentLinkBlock({ content: url, url, protocol, dns });
    }
}